import { Button, Flex, Grid, HStack, IconButton, Link, Stack, StackDivider, Text, VStack } from '@chakra-ui/react';
import { Link as ReactLink } from 'react-router-dom';
import { FaInfoCircle } from 'react-icons/fa';
import React from 'react';
import { BsFillFlagFill, BsPlusCircle } from 'react-icons/bs';
import { formatDate } from '@utils/dateUtils';

const ThunesFulfillmentCard = ({
  fulfillmentData,
  isSuperAdmin,
  onForceInitiateClick,
  // onOnHoldReasonClick,
  onDetailsClick,
  onRecentTransfersClick,
  onChecksClick,
  onFlagButtonClick,
  onTagsInfoClick
}) => {
  return (
    <VStack
      alignSelf={'flex-start'}
      w={{ base: '100%', md: '100%' }}
      maxW={'850px'}
      bg="backGround"
      borderRadius="12px"
      position="relative"
      divider={
        <StackDivider style={{ margin: '0' }} borderColor="whiteAlpha.300" />
      }
    >
      {fulfillmentData?.orderMetadata?.complianceFlagged ? (
        <IconButton
          position={'absolute'}
          rounded={'full'}
          top={-2}
          right={-2}
          bg={'altGray.500'}
          color={'red.500'}
          _hover={{
            background: 'red.500',
            color: 'altGray.500'
          }}
          size={'sm'}
          fontSize={'0.9rem'}
          fontWeight={400}
          icon={<BsFillFlagFill />}
          onClick={onFlagButtonClick}
        />
      ) : (
        <IconButton
          position={'absolute'}
          rounded={'full'}
          top={-2}
          right={-2}
          bg={'altGray.500'}
          color={'brand.200'}
          _hover={{
            background: 'brand.200',
            color: 'altGray.500'
          }}
          size={'sm'}
          fontSize={'0.9rem'}
          fontWeight={400}
          icon={<BsPlusCircle />}
          onClick={onFlagButtonClick}
        />
      )}
      {fulfillmentData?.tags && (
        <IconButton
          position={'absolute'}
          rounded={'full'}
          top={-2}
          left={-2}
          bg={'altGray.500'}
          color={'brand.200'}
          _hover={{
            background: 'red.500',
            color: 'altGray.500'
          }}
          size={'sm'}
          fontSize={'0.9rem'}
          fontWeight={400}
          icon={<FaInfoCircle />}
          onClick={onTagsInfoClick}
        />
      )}
      <Flex
        justifyContent="space-between"
        alignItems="flex-start"
        w="90%"
        m="1rem"
        direction={{ base: 'column', md: 'row' }}
        gap={2}
      >
        <HStack spacing={2}>
          <Text fontSize={{ base: 'sm', sm: 'md' }} color="gray">
            Order Id:
          </Text>
          <Text fontSize={{ base: 'sm', sm: 'md' }} color="white">
            {fulfillmentData.orderId}
          </Text>
          {fulfillmentData.isBoldPitchUser === true && (
            <Text fontSize={{ base: 'sm', sm: 'md' }} color="white">
              (Bold Pitch)
            </Text>
          )}
        </HStack>

        <HStack spacing={2}>
          <Text fontSize={{ base: 'sm', sm: 'md' }} color="gray">
            Created At:
          </Text>
          <Text fontSize={{ base: 'sm', sm: 'md' }} color="white">
            {formatDate(fulfillmentData.createAt)}
          </Text>
        </HStack>
      </Flex>
      <Grid
        gridTemplateColumns={{
          base: '1fr',
          md: `repeat(4, 1fr)`
        }}
        gap={2}
        alignItems={'flex-start'}
        w={'90%'}
        m={'1rem'}
        textAlign={{ base: 'end', md: 'start' }}
      >
        <Stack
          direction={{ base: 'row', md: 'column' }}
          justifyContent={'space-between'}
          height={'100%'}
        >
          <Text fontSize={'sm'} color={'gray'}>
            User
          </Text>
          <Link
            as={ReactLink}
            to={`/user/${fulfillmentData.userId}`}
            color="white"
            fontSize={'sm'}
            target="_blank"
          >
            <HStack pt={2}>
              <Text>{fulfillmentData.userName}</Text>
            </HStack>
          </Link>
        </Stack>

        <Stack
          direction={{ base: 'row', md: 'column' }}
          justifyContent={'space-between'}
          height={'100%'}
        >
          <Text fontSize={'sm'} color={'gray'}>
            Source
          </Text>
          <Link
            as={ReactLink}
            to={`/user/${fulfillmentData.userId}`}
            color="white"
            fontSize={'sm'}
            target="_blank"
          >
            <HStack pt={2}>
              <Text>{fulfillmentData.sourceAccountName || '-'}</Text>
            </HStack>
          </Link>
        </Stack>

        <Stack
          direction={{ base: 'row', md: 'column' }}
          justifyContent={'space-between'}
          height={'100%'}
        >
          <HStack>
            <Text fontSize={'sm'} color={'gray'}>
              Beneficiary
            </Text>
          </HStack>
          <Link
            as={ReactLink}
            to={`/user/${fulfillmentData.userId}`}
            color="white"
            fontSize={'sm'}
            target="_blank"
          >
            <Text>{fulfillmentData.beneficiaryName || '-'}</Text>
          </Link>
        </Stack>

        {/* <Stack
          direction={{ base: 'row', md: 'column' }}
          justifyContent={'space-between'}
          height={'100%'}
        >
          <Text fontSize={'sm'} color={'gray'}>
            Reason
          </Text>
          {fulfillmentData.onHoldReason?.length ? (
            <MdOutlineOpenInNew
              color={'gray'}
              cursor={'pointer'}
              onClick={() =>
                onOnHoldReasonClick({
                  fulfillmentId: fulfillmentData.fulfillmentId,
                  onHoldReason: fulfillmentData.onHoldReason
                })
              }
            />
          ) : (
            <Text fontSize={'sm'} color={'white'}>
              -
            </Text>
          )}
        </Stack> */}

        {/*NOTE :: Commenting this as its Obsolete Code, Uncomment if needed*/}
        {/*
        <Stack
          direction={{ base: 'row', md: 'column' }}
          justifyContent={'space-between'}
          height={'100%'}
        >
          <Text fontSize={'sm'} color={'gray'}>
            Checks
          </Text>
          <MdOutlineOpenInNew
            color={'gray'}
            cursor={'pointer'}
            onClick={() => {
              onChecksClick({
                orderId: fulfillmentData?.orderId
              });
            }}
          />
        </Stack>
        */}
        <Button
          size={'sm'}
          mt={{ base: 2, md: 0 }}
          ml={{ base: 0, md: 1 }}
          // rightIcon={<GrTrigger color="black" />}
          type="submit"
          rounded="full"
          color={'black'}
          colorScheme="brand"
          alignSelf={{ base: 'center', md: 'center' }}
          px={5}
          onClick={() => {
            onDetailsClick({
              fulfillmentId: fulfillmentData?.fulfillmentId
            });
            onRecentTransfersClick({
              userId: fulfillmentData.userId,
              orderId: fulfillmentData.orderId
            });
          }}
        >
          Details
        </Button>
      </Grid>
    </VStack>
  );
};

export default ThunesFulfillmentCard;
